import { useState, useEffect } from 'react';
import { getProjetsConsole, creerProjet, modifierProjet, supprimerProjet } from '../api';

/** Console de l'éditeur : les projets de « Bientôt », et qui s'y intéresse. */
const ETATS = { prevu: 'Prévu', en_cours: 'En cours', disponible: 'Disponible' };
const ROLES = { joueur: 'joueurs', coach: 'coachs', tresorier: 'trésoriers', admin_club: 'dirigeants', admin: 'dirigeants', super_admin: 'éditeur' };
const champ = { background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, color: 'var(--text)', padding: '7px 9px', fontSize: 13 };

function Fiche({ p, onEnregistre, onSupprime }) {
  const [f, setF] = useState({ icone: p.icone || '', titre: p.titre, description: p.description || '', etat: p.etat, ordre: p.ordre, visible: !!p.visible });
  return (
    <form onSubmit={e => { e.preventDefault(); onEnregistre(f); }} style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid var(--border)', display: 'grid', gap: 8 }}>
      <div style={{ display: 'flex', gap: 8 }}>
        <input style={{ ...champ, width: 52, textAlign: 'center' }} value={f.icone} maxLength={8} aria-label="Icône" onChange={e => setF({ ...f, icone: e.target.value })} />
        <input style={{ ...champ, flex: 1 }} value={f.titre} required maxLength={80} aria-label="Titre" onChange={e => setF({ ...f, titre: e.target.value })} />
      </div>
      <textarea style={{ ...champ, minHeight: 60, fontFamily: 'inherit' }} value={f.description} maxLength={300} aria-label="Description" onChange={e => setF({ ...f, description: e.target.value })} />
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', fontSize: 12.5 }}>
        <select style={champ} value={f.etat} aria-label="État" onChange={e => setF({ ...f, etat: e.target.value })}>
          {Object.entries(ETATS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        <label>Ordre <input style={{ ...champ, width: 56 }} type="number" value={f.ordre} onChange={e => setF({ ...f, ordre: e.target.value })} /></label>
        <label style={{ display: 'flex', gap: 5, alignItems: 'center' }}><input type="checkbox" checked={f.visible} onChange={e => setF({ ...f, visible: e.target.checked })} /> Visible</label>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button className="btn btn-primary" style={{ width: 'auto' }}>Enregistrer</button>
        <button type="button" className="btn btn-danger" style={{ width: 'auto' }} onClick={() => window.confirm(`Supprimer « ${p.titre} » et ses ${p.interesses} vote(s) ?`) && onSupprime()}>Supprimer</button>
      </div>
    </form>);
}

export default function ConsoleProjets({ notifier }) {
  const [projets, setProjets] = useState(null);
  const [ouvert, setOuvert] = useState(null);
  const [nouveau, setNouveau] = useState('');
  const charger = () => getProjetsConsole().then(r => setProjets(r.projets)).catch(e => notifier?.(e.message, 'error'));
  useEffect(() => { charger(); }, []);
  const agir = async (f, msg) => { try { await f(); notifier?.(msg, 'success'); charger(); } catch (e) { notifier?.(e.message, 'error'); } };
  if (!projets) return <div style={{ color: 'var(--muted)', padding: 12 }}>Chargement…</div>;
  return (
    <div>
      <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 12, lineHeight: 1.5 }}>
        Ce que voient les utilisateurs dans « Bientôt », en bas de page. Pas de prix ni de dates : seulement les projets et leur état.
        Le nombre d'intéressés n'est visible que de vous.
      </div>
      <form onSubmit={e => { e.preventDefault(); agir(() => creerProjet({ titre: nouveau }), 'Projet ajouté'); setNouveau(''); }}
            style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
        <input style={{ ...champ, flex: 1 }} value={nouveau} required maxLength={80} placeholder="Nouveau projet…" aria-label="Nouveau projet" onChange={e => setNouveau(e.target.value)} />
        <button className="btn btn-primary" style={{ width: 'auto' }}>Ajouter</button>
      </form>
      {projets.map(p => (
        <div key={p.id} className="card" style={{ marginBottom: 8, opacity: p.visible ? 1 : .55, borderColor: ouvert === p.id ? 'var(--accent)' : undefined }}>
          <button type="button" onClick={() => setOuvert(ouvert === p.id ? null : p.id)} aria-expanded={ouvert === p.id}
                  style={{ all: 'unset', cursor: 'pointer', display: 'flex', gap: 10, alignItems: 'center', width: '100%' }}>
            <span style={{ fontSize: 20 }}>{p.icone || '✨'}</span>
            <span style={{ flex: 1 }}>
              <b style={{ fontSize: 14 }}>{p.titre}</b>
              <span style={{ display: 'block', fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>
                {ETATS[p.etat]}{p.visible ? '' : ' · masqué'} · <b style={{ color: 'var(--text)' }}>{p.interesses} intéressé{p.interesses > 1 ? 's' : ''}</b>
                {p.interesses > 0 && ` (${Object.entries(p.par_role).map(([r, n]) => `${n} ${ROLES[r] || r}`).join(', ')} · ${p.clubs} club${p.clubs > 1 ? 's' : ''})`}
              </span>
            </span>
            <span style={{ color: 'var(--accent)' }}>{ouvert === p.id ? '▾' : '▸'}</span>
          </button>
          {ouvert === p.id && <Fiche p={p} onEnregistre={f => agir(() => modifierProjet(p.id, f), 'Projet enregistré')}
                                    onSupprime={() => { setOuvert(null); agir(() => supprimerProjet(p.id), 'Projet supprimé'); }} />}
        </div>))}
    </div>);
}
